import { render } from "./AccountLoginCode.vue?vue&type=template&id=1696795e"
import script from "./AccountLoginCode.vue?vue&type=script&lang=js"
export * from "./AccountLoginCode.vue?vue&type=script&lang=js"
script.render = render

export default script